var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-transformer',{ref:_vm.config.name,attrs:{"config":_vm.config},on:{"transformstart":function($event){return _vm.$emit('transform:start', $event)},"transformend":function($event){return _vm.$emit('transform:end', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }